import { styled } from 'styled-components';
import { Card } from '../UserReview';
import { Typography, tk, verticalGap } from '@sunwebgroup/ui-components';
import { useIntl } from '@/intl';

const Wrapper = styled(Card)`
  box-shadow: none;
  background-color: ${tk('color_semantic_bg_disabled')};
  display: flex;
  flex-direction: column;

  ${verticalGap('spacing_sm')}
`;

const Content = styled(Typography)`
  color: ${tk('color_semantic_text_subdued')};
`;

export function NoReviewsMessage() {
  const intl = useIntl();
  return (
    <Wrapper>
      <Typography $variant="body-md-bold" as="div">
        {intl.formatMessage({ id: 'reviews_no_reviews_title' })}
      </Typography>
      <Content $variant="body-sm" as="div">
        {intl.formatMessage({ id: 'reviews_no_reviews_content' })}
      </Content>
    </Wrapper>
  );
}
